var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-select",
    {
      attrs: {
        error: _vm.errorText,
        label: "Cidade",
        disabled: !_vm.state,
        loading: _vm.loading
      },
      model: {
        value: _vm.city,
        callback: function($$v) {
          _vm.city = $$v
        },
        expression: "city"
      }
    },
    [
      _c("option", { attrs: { value: "0", disabled: "", selected: "" } }),
      _vm._v(" "),
      _vm._l(_vm.cities, function(city, index) {
        return _c("option", { key: index, domProps: { value: city.id } }, [
          _vm._v(_vm._s(city.nome))
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04d94bf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04d94bf6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/IBGE/Cities.vue
// module id = null
// module chunks = 